import { render, staticRenderFns } from "./NavDesktopProducts.vue?vue&type=template&id=55eaedc4"
import script from "./NavDesktopProducts.vue?vue&type=script&lang=js"
export * from "./NavDesktopProducts.vue?vue&type=script&lang=js"
import style0 from "./NavDesktopProducts.vue?vue&type=style&index=0&id=55eaedc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports